import type { SxProps, Theme } from '@mui/material/styles';
import { MENU_BAR_HEADER_HEIGHT_PX } from 'components/core/MenuBar/styles';
import {
  leftMainContainerPosition,
  moduleContainerWidth,
} from 'components/core/Layout/layoutStyles';

export const pageShellSx: SxProps<Theme> = {
  bgcolor: 'grey.50',
  minHeight: `calc(100vh - ${MENU_BAR_HEADER_HEIGHT_PX})`,
  width: '100%',
  boxSizing: 'border-box',
};

export const loaderBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  py: 8,
};

export const footerBarSx: SxProps<Theme> = {
  position: 'fixed',
  bottom: 0,
  left: leftMainContainerPosition,
  width: moduleContainerWidth,
  bgcolor: 'background.paper',
  zIndex: 1,
  boxShadow: '0px -4px 4px -2px rgba(0, 0, 0, 0.15)',
};

export const footerInnerSx: SxProps<Theme> = {
  paddingTop: '11px',
  paddingBottom: '12px',
  paddingRight: '29px',
  paddingLeft: '16px',
  overflow: 'auto',
  '& > div': {
    flexShrink: 0,
  },
};

export const getMainContentSx = (isMobile: boolean): SxProps<Theme> => ({
  boxSizing: 'border-box',
  maxWidth: 900,
  margin: '0 auto',
  padding: isMobile ? 2 : '24px 42px',
  paddingTop: isMobile ? 3 : 5,
});

export const backButtonBoxSx: SxProps<Theme> = {
  mb: 2,
};

export const backButtonIconSx: SxProps<Theme> = {
  fontSize: 14,
};

export const lockedAlertSx: SxProps<Theme> = {
  mt: 2,
  borderRadius: 1,
};

export const nameFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
  },
};

export const footerSpacerSx: SxProps<Theme> = {
  marginBottom: '85px',
};
